import React from "react";
import PropTypes from "prop-types";

const Error = ({ className, color }) => (
  <svg
    className={className}
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.1154 0.125H10.8846L0.125 10.8846V26.1154L10.8846 36.875H26.1154L36.875 26.1154V10.8846L26.1154 0.125ZM32.7917 24.4208L24.4208 32.7917H12.5792L4.20833 24.4208V12.5792L12.5792 4.20833H24.4208L32.7917 12.5792V24.4208ZM24.2779 9.84333L18.5 15.6213L12.7221 9.84333L9.84333 12.7221L15.6213 18.5L9.84333 24.2779L12.7221 27.1567L18.5 21.3787L24.2779 27.1567L27.1567 24.2779L21.3787 18.5L27.1567 12.7221L24.2779 9.84333Z"
      fill={color}
    />
  </svg>
);

Error.defaultProps = {
  color: "red",
  classNames: "",
};

Error.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default Error;
